import React from 'react'
import { connect } from 'react-redux'
import { fetchProducts } from '../../actions/product-actions'
import { Grid, Row, Table } from 'react-bootstrap'
import qs from 'qs'

import SearchBar from '../../components/SearchBar'
import Breadcrumbs from '../../components/Breadcrumbs'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../messages'
import FontAwesome from 'react-fontawesome'

class ProductOverview extends React.Component {

  constructor() {
    super()
    this.state = { query: undefined }
  }

  componentDidMount() {
    if (this.props.location.search) {
      let params = qs.parse(this.props.location.search.substring(1))
      this.setState({ query: params.query})
      this.props.fetchProducts(params.query)
    }
  }

  search(query) {
    this.props.fetchProducts(query)
  }

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  }

  render() {
    const { searchResults } = this.props

    return <Grid>
      <Breadcrumbs/>
      <SearchBar 
        value={this.state.query || searchResults.query} 
        action='/producten' 
        placeholder='Zoek product' 
        callback={(query) => this.search(query)} 
      />

      <Row>
        <div className='tablescontainer'>
        { searchResults.length > 0 ? <Table striped>
            <thead>
              <tr>
                <th>Naam</th>
                <th></th>
                <th>EAN</th>
                <th></th>
                <th>Verlengbaar</th>
                <th>Werkmaatschappij</th>
              </tr>
            </thead>
            <tbody>
              { searchResults.map((product, index) =>
                <tr key={index} >
                  <td onClick={() => this.props.history.push(`/producten/${product.id}`)} >{product.name}</td>
                  <td>
                        <FontAwesome name="copy" onClick={()=> this.copyToClipboard(product.name)} />
                   </td>
                  <td onClick={() => this.props.history.push(`/producten/${product.id}`)} >{product.ean}</td>
                  <td> <FontAwesome name="copy" onClick={()=> this.copyToClipboard(product.ean)} /> </td>
                  <td onClick={() => this.props.history.push(`/producten/${product.id}`)}>{product.extendable ? "Ja" : "Nee"}</td>
                  <td onClick={() => this.props.history.push(`/producten/${product.id}`)}>{product.subsidiary ? product.subsidiary.name : "" }</td>
                </tr>
              )}
            </tbody>
          </Table>
        : <SearchInfo />}
        </div>
      </Row>
    </Grid>
  }
}

let SearchInfo = () => (
  <div>
    <p>{SEARCH_INSTRUCTIONS}</p>
    <p>Zoek op:</p>
    <ul>
      <li>Naam</li>
      <li>EAN</li>
      <li>Contentreferenties</li>
    </ul>
    <p>{NO_SEARCH_RESULTS}</p>
  </div>
)

export default connect((state) => { return { searchResults: state.products.searchResults }}, {
  fetchProducts
})(ProductOverview)
